<template>
    <b-card title="Add Tour" class="card_body">
        <hr>
        <b-input-group prepend="Tour">
            <!-- <b-input type="text" placeholder="Event title" v-model="event.title"></b-input> -->
            <b-form-select v-model="event_form_data.tour" :options="tours"></b-form-select>
        </b-input-group>
        <br>
        <b-input-group prepend="Date">
            <b-form-datepicker v-model="event_form_data.date"></b-form-datepicker>
        </b-input-group>
        <br>
        <b-input-group prepend="Time">
            <!--<b-form-datepicker v-model="event_form_data.start" value-as-date></b-form-datepicker>-->
            <b-form-timepicker v-model="event_form_data.time" locale="it" minutes-step="15"></b-form-timepicker>
        </b-input-group>
        <br>
        <b-input-group prepend="Max seats">
            <b-form-spinbutton id="demo-sb" v-model="event_form_data.occupancy" min="0" max="30"></b-form-spinbutton>
        </b-input-group>
        <br>
        <!-- <color-picker @colorPicked="selectColor" :color="event.cssClass" /> -->
        <hr>
        <b-input-group>
            <b-button @click="handleSubmit" variant="success">Add</b-button>
        </b-input-group>
    </b-card>
</template>

<script>
    //import ColorPicker from './ColorPicker';

    import moment from 'moment'
    moment.locale('IT');

    export default {
        name: 'EventForm',
        data(){
            return {
                tours: [],
                event_form_data: {
                    date: '',
                    time: '10:00:00',
                    occupancy: 20,
                    tour: null
                }
            }
        },
        methods: {
            async handleSubmit(){
                this.$emit('add-event', this.event_form_data);
                this.resetValues();
            },
            setDate : function(_date) {
                let temp_date = new Date(_date);
                this.event_form_data.date = new moment(temp_date).format('YYYY-M-D'); //temp_date.getFullYear() + '-' + (temp_date.getMonth() + 1) + '-' + temp_date.getDate();
            },
            setTime : function(_date) {
                let temp_date = new Date(_date);
                this.event_form_data.time = new moment(temp_date).format('HH:mm');
            },
            selectColor(color){
                this.event = {
                    ...this.event,
                    cssClass: color
                }
            },
            resetValues(){
                this.event_form_data = {
                    date: '',
                    time: '10:00:00',
                    occupancy: 20,
                    guida: null
                }
            }
        },
        created() {
            this.$firebase.toursCollection.get().then( function(querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());
                    let tour = doc.data();
                    let tour_w_id = tour;
                    tour_w_id.ID =  doc.id
                    this.tours.push({
                        value: tour_w_id,
                        text: tour.Title + ' - ' + tour.Language
                    });
                }.bind(this));
            }.bind(this));
        }
    }
</script>

<style>

    .card_body{
        /*background-color: #ffda9c;*/
        background: rgb(194, 255, 161);
        background: linear-gradient(150deg, rgb(189, 255, 161) 34%, rgb(106, 255, 65) 100%);
        padding:15px 5px 0 5px;
    }

    form {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
    }
    .input-holder {
        margin: 10px 0;
        display: flex;
        justify-content: flex-start;
    }
    .vdp-datepicker {
        width: 100%;
    }
    .vdp-datepicker > div > input {
        width: 77%;
    }
    .input-holder > button {
        justify-self: center;
        padding: 12px 25px;
        border-radius: 0;
        text-transform: uppercase;
        font-weight: 600;
        background: orangered;
        color: white;
        border: none;
        font-size: 14px;
        letter-spacing: -0.1px;
        cursor: pointer;
    }
    input,
    textarea {
        padding: 12px 15px;
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-radius: 0;
        width: 70%;
        opacity: 0.8;
        font-size: 15px;
        font-weight: normal;
    }
    input:focus,
    textarea:focus,
    button:focus {
        border: 2px solid orangered;
        outline: none;
        box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.2);
    }
</style>
